import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-display-element"
export default class extends Controller {
  static targets = ["element", "checkbox"];

  declare elementTarget: HTMLElement;
  declare hasElementTarget: boolean;
  declare checkboxTargets: HTMLInputElement[];
  declare hasCheckboxTarget: boolean;

  connect() {
    if (this.hasCheckboxTarget) {
      this.toggle();
    }
  }

  toggle() {
    // element hidden si aucune checkbox cochée
    if (this.hasCheckboxTarget && this.hasElementTarget) {
      if (this.checkboxTargets.some((cb) => cb.checked)) {
        this.elementTarget.classList.remove("hidden");
      } else {
        this.elementTarget.classList.add("hidden");
      }
      // toggle hidden si l'élément cible est trouvé
    } else if (this.hasElementTarget) {
      this.elementTarget.classList.toggle("hidden");
    }
  }
}
